import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, Copy } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export default function MediaPage() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ url: "", label: "", kind: "image" });
  const load = () => api.get("/media").then((r) => setItems(r.data.items));
  useEffect(() => { load(); }, []);
  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/media", form); setForm({ url: "", label: "", kind: "image" }); toast.success("Added"); load(); }
    catch (err) { toast.error(formatApiError(err)); }
  };
  const del = async (id) => { if (!window.confirm("Remove this media?")) return; await api.delete(`/media/${id}`); load(); };
  const copy = (u) => { navigator.clipboard?.writeText(u); toast.success("Copied"); };
  return (
    <div className="space-y-5" data-testid="admin-media-page">
      <div><h1 className="font-display font-extrabold text-2xl text-gray-900">Media Library</h1>
      <p className="text-sm text-gray-500 mt-1">Save URLs here for easy reuse across vehicles, blog posts and Instagram.</p></div>
      <form onSubmit={add} className="bg-white rounded-xl border border-gray-200 p-4 grid grid-cols-1 md:grid-cols-4 gap-2">
        <input required placeholder="Media URL" value={form.url} onChange={(e) => setForm({ ...form, url: e.target.value })} className="rounded-md border border-gray-200 px-3 py-2 text-sm md:col-span-2" />
        <input placeholder="Label (optional)" value={form.label} onChange={(e) => setForm({ ...form, label: e.target.value })} className="rounded-md border border-gray-200 px-3 py-2 text-sm" />
        <select value={form.kind} onChange={(e) => setForm({ ...form, kind: e.target.value })} className="rounded-md border border-gray-200 px-3 py-2 text-sm"><option value="image">Image</option><option value="document">Document</option></select>
        <button className="btn-primary md:col-span-4"><Plus size={14} /> Add to Library</button>
      </form>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {items.map((m) => (
          <div key={m.id} className="rounded-lg border border-gray-200 bg-white overflow-hidden">
            {m.kind === "image" ? <img src={m.url} alt="" className="w-full aspect-square object-cover" /> : <div className="aspect-square bg-gray-50 flex items-center justify-center text-xs text-gray-400">DOC</div>}
            <div className="p-2">
              <div className="text-xs font-semibold truncate">{m.label || "(no label)"}</div>
              <div className="flex gap-2 mt-1.5">
                <button onClick={() => copy(m.url)} className="text-gray-600 hover:text-[#940C2C]" title="Copy URL"><Copy size={13} /></button>
                <button onClick={() => del(m.id)} className="text-red-600 ml-auto"><Trash2 size={13} /></button>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="col-span-full text-center text-gray-400 py-10">No media yet.</div>}
      </div>
    </div>
  );
}
